import { Component } from '@angular/core';

import { MonitoringService } from '@core/services/monitoring.service';
import { ReportAbstract } from '@features/reports/abstracts/report.abstract';
import { ReportsService } from '@features/reports/services/reports.service';
import { Report } from '@shared/enums/report.enum';

interface OpportunitySummary {
  title: string;
  firstName: string;
  middleName: string;
  lastName: string;
  settlementDate: string;
  settlementAmount: number;
  opportunityType: string;
}

@Component({
  templateUrl: './opportunities.component.html',
  styleUrls: ['./opportunities.component.scss']
})
export class OpportunitiesReportComponent extends ReportAbstract<OpportunitySummary> {
  title = 'Opportunities';
  columns = [
    { name: 'Name' },
    { name: 'Settlement date', prop: 'settlementDate' },
    { name: 'Settlement amount', prop: 'settlementAmount' },
    { name: 'Type', prop: 'opportunityType' }
  ];
  csvHeaders = [
    {
      label: 'Client Id',
      value: 'clientId'
    },
    {
      label: 'Title',
      value: 'title'
    },
    {
      label: 'Last name',
      value: 'lastName'
    },
    {
      label: 'Workflow Status Type',
      value: 'opportunityWorkflowStatusType'
    },
    {
      label: 'Loan Type',
      value: 'opportunityType'
    },
    {
      label: 'Liberty Loan Id',
      value: 'libertyLoanid'
    },
    {
      label: 'Submitted Date',
      value: 'opportunitySubmittedDate'
    },
    {
      label: 'Submission Type Key',
      value: 'submissionTypeKey'
    },
    {
      label: 'Created Date',
      value: 'opportunityCreatedDate'
    },
    {
      label: 'Outcome Date',
      value: 'outcomeDate'
    },
    {
      label: 'Settlement Date',
      value: 'settlementDate'
    },
    {
      label: 'Settlement Amount',
      value: 'settlementAmount'
    },
    {
      label: 'First Home Owner',
      value: 'firstHomeOwner'
    },
    {
      label: 'Product',
      value: 'product'
    },
    {
      label: 'Interest Type',
      value: 'interestType'
    },
    {
      label: 'Fixed Rate Term',
      value: 'fixedRateTerm'
    },
    {
      label: 'Approved LVR',
      value: 'approvedLvr'
    },
    {
      label: 'Approved Loan Amount',
      value: 'approvedLoanAmount'
    },
    {
      label: 'Maturity Date',
      value: 'maturityDate'
    }
  ];

  constructor(
    reportsService: ReportsService,
    monitoringService: MonitoringService
  ) {
    super(Report.Opportunities, reportsService, monitoringService);
  }
}
